//用户条款 
const agreement = r =>
    require.ensure([], () => r(require("@/pages/customize/agreement")), "agreement");
//用户协议-新20230411
const userAgreement = r =>
require.ensure([], () => r(require("@/pages/customize/userAgreement")), "userAgreement");
//隐私政策-新20230411
const privacyAgreement = r =>
    require.ensure([], () => r(require("@/pages/customize/privacyAgreement")), "privacyAgreement");
// ---------------------------------------------获客赋能--------------------------------------------
//20200206获客H5__代理人分享页面
const agentShare = r =>
    require.ensure([], () => r(require("@/pages/agentShare/index")), "agentShare");
//获客赋能_孩子保险配置
const customizeHKWa = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeHKWa")), "customizeHKWa");
//获客赋能_女性保险配置
const customizeWm = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeWm")), "customizeWm");
//获客赋能_家庭保险配置
const customizeFml = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeFml")), "customizeFml");
//获客赋能_爱无忧保险配置_视频
const customizeAwy7 = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeAwy7")), "customizeAwy7");
//获客赋能_康惠保2020保险配置_视频
const customizeKhb8 = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeKhb8")), "customizeKhb8");
//获客赋能_康惠保青春定期保险配置_视频
const customizeKhbqc = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeKhbqc")), "customizeKhbqc");
//获客赋能_通用版_视频
const customizeTy = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeTy")), "customizeTy");
//获客赋能_父母版_视频
const customizePar = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizePar")), "customizePar");
//获客赋能_众惠百万医疗
const customizeZh = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeZh")), "customizeZh");
//获客赋能_家庭支柱保险
const customizeHome = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeHome")), "customizeHome");
//获客赋能_课程直播张楠
const customizeKczn = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeKczn")), "customizeKczn");
//获客赋能_课程陈西希
const customizeKccx = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeKccx")), "customizeKccx");
//获客赋能_90后保险配置
const customizeYoung = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeYoung")), "customizeYoung");

//获客赋能_重疾险应该怎么选
const customizeIllness = r =>
    require.ensure([], () => r(require("@/pages/agentShare/customizeIllness")), "customizeIllness");
//获客赋能_大小公司怎么选
const hkCompany = r =>
    require.ensure([], () => r(require("@/pages/agentShare/hkCompany")), "hkCompany");
//获客赋能_少儿重疾险配置
const youthIll = r =>
    require.ensure([], () => r(require("@/pages/agentShare/youthIll")), "youthIll");
//获客赋能_30岁男性保险配置
const midMen = r =>
    require.ensure([], () => r(require("@/pages/agentShare/midMen")), "midMen");
//获客赋能_手把手教你买保险
const inPerson = r =>
    require.ensure([], () => r(require("@/pages/agentShare/inPerson")), "inPerson");
//获客赋能_30岁女性保险配置
const midWomen = r =>
    require.ensure([], () => r(require("@/pages/agentShare/midWomen")), "midWomen");
//获客赋能_医疗险避坑指南
const MedicalInsurance = r =>
    require.ensure([], () => r(require("@/pages/agentShare/MedicalInsurance")), "MedicalInsurance");
//获客赋能_糖尿病能否买保险
const diabetes = r =>
    require.ensure([], () => r(require("@/pages/agentShare/diabetes")), "diabetes");
//获客赋能_乙肝患者保险配置
const hepatitisB = r =>
    require.ensure([], () => r(require("@/pages/agentShare/hepatitisB")), "hepatitisB");
//获客赋能_意外险应该怎么买
const accIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/accIns")), "accIns");
// 获客赋能_大童1V1保险服务
const privateCustom = r =>
    require.ensure([], () => r(require("@/pages/agentShare/privateCustom")), "privateCustom");
// 获客赋能_五一出行怎么选保险
const trip = r =>
    require.ensure([], () => r(require("@/pages/agentShare/trip")), "trip");
// 获客赋能_信泰如意人生守护
const xtHappyLife = r =>
    require.ensure([], () => r(require("@/pages/agentShare/xtHappyLife")), "xtHappyLife");
// 获客赋能_定期寿险怎么选
const termLifeIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/termLifeIns")), "termLifeIns");
// 获客赋能_琴童尊享终身寿险
const qtvipwhoelifeins = r =>
    require.ensure([], () => r(require("@/pages/agentShare/qtvipwhoelifeins")), "qtvipwhoelifeins");
// 获客赋能_单身青年保险配置
const singleAf = r =>
    require.ensure([], () => r(require("@/pages/agentShare/singleAf")), "singleAf");
// 获客赋能_单身青年保险配置
const intIns = r =>
    require.ensure([], () => r(require("@/pages/agentShare/intIns")), "intIns");
// 获客赋能_高血压人群保险配置
const hypertension = r =>
    require.ensure([], () => r(require("@/pages/agentShare/hypertension")), "hypertension");
commercialInsurance
// 获客赋能_社保与商保的区别
const commercialInsurance = r =>
    require.ensure([], () => r(require("@/pages/agentShare/commercialInsurance")), "commercialInsurance");
// 获客赋能_母亲节保险怎么买
const mothersDay = r =>
    require.ensure([], () => r(require("@/pages/agentShare/mothersDay")), "mothersDay");
// 获客赋能_甲状腺结节保险配置
const thyroidNodule = r =>
    require.ensure([], () => r(require("@/pages/agentShare/thyroidNodule")), "thyroidNodule");
// 获客赋能_缴费期限怎么选
const payment = r =>
    require.ensure([], () => r(require("@/pages/agentShare/payment")), "payment");
//获客赋能_预算有限保险配置
const limited = r =>
    require.ensure([], () => r(require("@/pages/agentShare/limited")), "limited");
//获客赋能_预算有限保险配置
const childrenAccident = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childrenAccident")), "childrenAccident");
//获客赋能_意外+医疗人人必备
const medicalAccident = r =>
    require.ensure([], () => r(require("@/pages/agentShare/medicalAccident")), "medicalAccident");
//获客赋能_大童定方案定制服务
const schemeCustomization = r =>
    require.ensure([], () => r(require("@/pages/agentShare/schemeCustomization")), "schemeCustomization");
//获客赋能_保单托管
const policyCustody = r =>
    require.ensure([], () => r(require("@/pages/agentShare/policyCustody")), "policyCustody");
//获客赋能_孩子保费测算
const childrenCalculation = r =>
    require.ensure([], () => r(require("@/pages/agentShare/childrenCalculation")), "childrenCalculation");
//获客赋能_防癌医疗险怎么选
const preventCancer = r =>
    require.ensure([], () => r(require("@/pages/agentShare/preventCancer")), "preventCancer");
//获客赋能_高端医疗保险怎么选
const topCure = r =>
    require.ensure([], () => r(require("@/pages/agentShare/topCure")), "topCure");
//获客赋能_3招看懂保险合同
const insuranceContract = r =>
    require.ensure([], () => r(require("@/pages/agentShare/insuranceContract")), "insuranceContract");

let egoRouter1 = [
    {
        path: "/agreement",
        component: agreement,
        meta: {
            requireAuth: false,
            title: "用户协议"
        }
    },
    // 获客赋能-疫情
    {
        path: "/p_get1",
        component: agentShare,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_hz",
        component: customizeHKWa,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_wm",
        component: customizeWm,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_fml",
        component: customizeFml,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_awy",
        component: customizeAwy7,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_khb",
        component: customizeKhb8,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_khbqc",
        component: customizeKhbqc,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_ty",
        component: customizeTy,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_par",
        component: customizePar,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_zh",
        component: customizeZh,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_home",
        component: customizeHome,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_kczn",
        component: customizeKczn,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_kccx",
        component: customizeKccx,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_90pz",
        component: customizeYoung,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险咨询"
        }
    },
    {
        path: "/hkfn_ill",
        component: customizeIllness,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_company",
        component: hkCompany,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_youthIll",
        component: youthIll,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_midMen",
        component: midMen,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_inperson",
        component: inPerson,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_midWomen",
        component: midWomen,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_medIns",
        component: MedicalInsurance,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_diabetes",
        component: diabetes,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_hepatitisB",
        component: hepatitisB,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_accIns",
        component: accIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_privateCustom",
        component: privateCustom,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_51trip",
        component: trip,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_xthl",
        component: xtHappyLife,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_tli",
        component: termLifeIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_qtvip",
        component: qtvipwhoelifeins,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_singleAf",
        component: singleAf,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_intIns",
        component: intIns,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_hypertension",
        component: hypertension,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_comIns",
        component: commercialInsurance,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_mday",
        component: mothersDay,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_thyroid",
        component: thyroidNodule,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_pay",
        component: payment,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_limited",
        component: limited,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_childrenAccident",
        component: childrenAccident,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_medicalAccident",
        component: medicalAccident,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_scheme",
        component: schemeCustomization,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_policyCustody",
        component: policyCustody,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_childrenCalculation",
        component: childrenCalculation,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_preventCancer",
        component: preventCancer,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_topCure",
        component: topCure,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/hkfn_insuranceContract",
        component: insuranceContract,
        meta: {
            requireAuth: false,
            isWxData: true,
            title: "大童保险管家"
        }
    },
    {
        path: "/userAgreement",
        component: userAgreement,
        meta: {
            requireAuth: false,
            title: "快保APP用户协议"
        }
    },
    {
        path: "/privacyAgreement",
        component: privacyAgreement,
        meta: {
            requireAuth: false,
            title: "隐私政策"
        }
    },

]
export default egoRouter1



// WEBPACK FOOTER //
// ./src/router/egoRouter1.js